<template>
    <div id="main">
        <!-- <NavBar></NavBar>
        <div class="container"> -->
            <router-view/>
        <!-- </div> -->
    </div>
</template>

<script>
import NavBar from '@/components/NavBar';
export default {
    components:{
        NavBar
    },

    data() {
        return {

        }
    }
}
</script>

<style scoped>
    /* #main {
        background: lightseagreen;
    } */
</style>